export class BHEemitidaFilter {
   emisorID: string;
   nombreReceptor: string;
   rutReceptor: string = "";
   folio: number;
   fechaDesde: Date;
   fechaHasta: Date;
   fechaEmision: Date;
   regionReceptor: string;
   comunaReceptor: string;
   importacionMasivaId: string;
   anulada: boolean;
   importada: boolean;
   terceros: boolean;
}
